import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';
import { ReservationFamilyComponent } from './reservation-family.component';
import { ReservationFamilyCreateComponent } from './reservation-family-create.component';
import { ReservationFamilyDetailComponent } from './reservation-family-detail.component';
import { ReservationFamilyDeletePopupComponent } from './reservation-family-delete-dialog.component';


@Injectable()
export class ReservationFamilyResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'startDate,desc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const reservationFamilyRoute: Routes = [
    {
        path: 'reservation-family',
        component: ReservationFamilyComponent,
        resolve: {
            'pagingParams': ReservationFamilyResolvePagingParams
        },
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.reservation-family.home.title'
        }
    }, {
        path: 'reservation-family-new',
        component: ReservationFamilyCreateComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.reservation-family.home.title'
        }
    }, {
        path: 'reservation-family/:id',
        component: ReservationFamilyDetailComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.reservation-family.home.title'
        }
    }
];

export const reservationFamilyPopupRoute: Routes = [
     {
            path: 'reservation-family/:id/delete',
            component: ReservationFamilyDeletePopupComponent,
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
                pageTitle: 'jYoguiApp.reservation-family.home.title'
            },
            outlet: 'popup'
        }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-family/reservation-family.route.ts